import styled from "@emotion/styled";
import { grayScale, hanghae, swc } from "@teamsparta/design-system";
import { fontPretendard } from "@teamsparta/design-system/dist/font/font";
import { DESKTOP } from "@/themes/device";

export const Cta = styled.button<{ width?: number }>`
  height: 55px;
  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #fff;
  background-color: ${hanghae.orangeRed100};
  display: block;
  margin: 0 auto;
  padding: 18px 0;
  width: ${({ width }) => (width ? `${width}px` : "328px")};
  border-radius: 8px;
  border: none;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    background-color: ${grayScale.gray30};
  }
`;
